import { apiUrl as API_BASE_URL } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';

// src/services/driverReservationsApi.js
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
  }
});

export const DriverReservationsApi = {
  // Basic CRUD operations
  getAll: () => api.get('driver-reservations/'),
  getById: (id) => api.get(`driver-reservations/${id}/`),
  create: (data) => api.post('driver-reservations/', data),
  update: (id, data) => api.put(`driver-reservations/${id}/`, data),
  delete: (id) => api.delete(`driver-reservations/${id}/`),
  
  // Custom endpoints
  getActive: () => api.get('driver-reservations/active/'),
  getArchived: (searchParams) => api.get('driver-reservations/archived/', { params: searchParams }),
  // Add more custom endpoints as needed
};

// Add request interceptor to include token
api.interceptors.request.use(async (config) => {
  const token = await UserProfile.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});